import { NeedDto, UserDto } from '@act/shared/data-transfer-objects';
import { HeaderCellConfig } from 'toolkit/tables/types/header.types';
import { PaginationBounds } from 'toolkit/tables/types/table.types';
import { DocketNeedsColumnKeys } from './utilities/docketNeedsColumnKeys.type';
import NeedTableRow from './need-table-row';
import ScrollableTable from './ScrollableTable';

export type NeedDtoWithMember = NeedDto & { member: UserDto };

const headerCellConfig: HeaderCellConfig<DocketNeedsColumnKeys>[] = [
  {
    key: 'member',
    label: 'Member',
    sortable: true,
  },
  {
    key: 'issueLabel',
    label: 'Issue',
    sortable: true,
  },
  {
    key: 'task',
    label: 'Task',
    sortable: true,
  },
  {
    key: 'dueDate',
    label: 'Due Date',
    sortable: true,
  },
  {
    key: 'ellipsis-menu',
    width: 56,
  },
  {
    key: 'link-to-feed',
    width: 56,
  },
];

export interface DocketNeedsTableViewProps {
  needs: NeedDtoWithMember[];
  totalRecords: number;
  bounds: PaginationBounds;
  setBounds: React.Dispatch<React.SetStateAction<PaginationBounds>>;
  handleTableChange: (params: {
    orderBy: DocketNeedsColumnKeys;
    orderDirection: 'asc' | 'desc';
    pageSize: number;
    pageStart: number;
  }) => void;
  onExtendTimeWindow: (needId: number) => void;
  isLoading?: boolean;
}

export default function DocketNeedsTableView({
  needs,
  totalRecords,
  bounds,
  setBounds,
  handleTableChange,
  onExtendTimeWindow,
  isLoading,
}: DocketNeedsTableViewProps) {
  return (
    <ScrollableTable
      data={needs}
      dataRowElement={props =>
        NeedTableRow({
          ...props,
          onExtendTimeWindow,
        })
      }
      headerCells={headerCellConfig}
      totalRecords={totalRecords}
      dispatchAction={handleTableChange}
      rowKeyGenerator={entry => `need-${entry.id}`}
      isLoading={isLoading}
      bounds={bounds}
      setBounds={setBounds}
    />
  );
}
